import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Dialog from '@material-ui/core/Dialog';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import { getWindowDimensions, isEmpty} from '../modules/appLibrary';
import { imageclose } from '../modules/imagedlgstore';
import InnerImageZoom from 'react-inner-image-zoom'
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.css'

export default function ImageDialog(props) {
    const open = useSelector(state => state.imgdlg.open);
    const images = useSelector(state => state.imgdlg.images);
    const def = useSelector(state => state.imgdlg.default);

    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [filename, setfilename] = useState(def);
    const [memo, setmemo] = useState('');
    const [imgsrc, setimgsrc] = useState('');

    const dispatch = useDispatch();

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isEmpty(images)) return;
        let image = images.find(e => e.filename === def);
        if (!isEmpty(image)) {
            setimgsrc(image.imageurl);
            setfilename(image.filename);
            setmemo(image.note);
        }
    }, [def]);

    function handleClose() {
        dispatch(imageclose());
    };

    function imageClick(image) {
        if (isEmpty(images)) return;
        let img = images.find(e => e.filename === image.filename);
        if (!isEmpty(img)) {
            setimgsrc(img.imageurl);
            setfilename(img.filename);
            setmemo(img.note);
        }
    }

    return (
        <Dialog
            fullWidth={true}
            maxWidth={"md"}
            open={open}
            onClose={handleClose}
        >
        <div style={{ position: 'relative' }}>
            <IconButton
                style={{ position: 'absolute', right:8, top:0, color:'#555' }}
                onClick={handleClose}
            >
            <Icon>close</Icon>
            </IconButton>
            {images===null?null:
            <div style={{ display: 'flex', width: '100%', height: windowDimensions.height - 120, marginTop: 30 }}>
                <div style={{ width: 150, paddingLeft: 10, overflowY: 'auto', borderRight: '1px solid #aaa' }}>
                    {images.map(image =>
                        <img src={image.imageurl} alt={image.filename}
                            onClick={()=>imageClick(image)}
                            style={{ width: 100, height: 100, objectFit: 'cover', margin:'1px 5px', padding:5, border: '1px solid #ccc' }}
                        />
                    )}
                </div>
                    <div style={{ flex: 1, marginLeft: 20 }}>
                        <div style={{ display: 'table-cell', height: windowDimensions.height - 180 }}>
                            <div style={{ maxWidth: '90%', maxHeight: '100%', width: 'auto', height: 'auto'}}>
                                <InnerImageZoom  src={imgsrc}   />
                            </div>
                            <div style={{ marginLeft: 20 }}>
                                <div style={{ marginTop: 10 }}>{filename}</div>
                                <div style={{ marginTop: 10, width: '80%' }}>
                                    {memo}
                                </div>
                            </div>
                       </div>
                </div>
            </div>
            }
        </div>
       </Dialog>
    );
}
